// extracted by mini-css-extract-plugin
export default {"centeredLayout":"style_centeredLayout__Zu-fQ","contentContainer":"style_contentContainer__ntzJ9"};